<script>
export default {
    wrong_password: `Das eingegebene Passwort ist nicht korrekt.`,
    email_not_verified: `Die E-Mail-Adresse ist noch nicht verifiziert. Wenn du keine E-Mail erhalten hast, klicke hier, um sie erneut zu senden.`,
    model_saved: `Modell erfolgreich gespeichert.`,
    entry_Saved: `Eintrag erfolgreich gespeichert.`,
    entry_updated: `Eintrag erfolgreich aktualisiert.`,
    generic_error: `Ein Fehler ist aufgetreten. Bitte versuche es später erneut.`,
    validation: {
        choose_Wallet: 'Bitte wähle ein Wallet-Konto aus',
        choose_Category: 'Bitte wähle eine Kategorie aus',
        insert_amount: 'Bitte gib einen Betrag ein',
        choose_Wallet_transfer: 'Bitte wähle ein anderes Wallet für die Überweisung aus',
        insert_payee: 'Bitte gib einen Empfängernamen ein',
        end_date_greater_than_start_date: 'Das Enddatum muss nach dem Startdatum liegen',
        choose_start_date: 'Bitte wähle ein Startdatum aus',
        end_date_greater_than_today: 'Das Enddatum muss nach heute liegen',
        start_date_greater_than_today: 'Das Startdatum muss nach heute liegen',
        insert_model_name: 'Bitte gib einen Modellnamen ein',
    },
    login: {
        not_verified_email: `Die E-Mail-Adresse ist noch nicht verifiziert. Wenn du keine E-Mail erhalten hast, klicke hier, um sie erneut zu senden.`,
        not_valid_password: `Das eingegebene Passwort ist nicht korrekt.`,
    },
    wallet: {
        are_you_sure: 'Bist du sicher, dass du dieses Wallet archivieren möchtest?',
        archived: 'Wallet archiviert',
        restored: 'Wallet wiederhergestellt',
        saved: 'Wallet gespeichert',
        wrong_Wallet: 'Bitte wähle einen korrekten Wallet-Typ aus',
        wallet_name: 'Bitte gib einen Namen für das Wallet ein',
        wallet_currency: 'Bitte wähle eine Währung für das Wallet aus',
        invoice_date: 'Bitte wähle ein Rechnungsdatum aus',
        closing_date: 'Bitte wähle ein Abschlussdatum aus',
        payment_account: 'Bitte wähle ein Zahlungskonto aus',
        installment: 'Bitte wähle einen Ratenwert aus',
        voucher_value: 'Bitte gib einen Gutscheinwert ein',
    },
    workspace: {
        updated: 'Arbeitsbereich aktualisiert',
        added: 'Arbeitsbereich hinzugefügt',
        user_not_fount: 'Benutzer nicht gefunden',
        user_unshared: 'Benutzer aus dem Arbeitsbereich entfernt',
        confirm_delete: 'Bist du sicher, dass du diesen Arbeitsbereich löschen möchtest?',
        deleted: 'Arbeitsbereich erfolgreich gelöscht'
    },
    search: {
        no_results: 'Keine Ergebnisse gefunden',
        please_set_date: 'Bitte wähle ein Start- und Enddatum aus',
    },
    delete_entry: 'Bist du sicher, dass du diesen Eintrag löschen möchtest?',
    archive_debit: 'Bist du sicher, dass du diese Schuld archivieren möchtest?',
    we_are_loading_your_data: 'Wir laden deine Daten...',
    install: 'Installiere unsere App aus dem Play Store!',
    offline: 'Du bist offline. Bitte überprüfe deine Internetverbindung.',
    chart: {
        no_data: 'Keine Daten zum Anzeigen',
        no_data_selected: 'Keine Daten ausgewählt',
    },
    label: {
        label_saved: 'Label erfolgreich gespeichert',
        label_deleted: 'Label erfolgreich gelöscht',
        label_archived: 'Label erfolgreich archiviert',
        label_restored: 'Label erfolgreich wiederhergestellt',
        label_name: 'Bitte gib einen Namen für das Label ein',
        label_color: 'Bitte wähle eine Farbe für das Label aus',
        delete_label: 'Bist du sicher, dass du dieses Label löschen möchtest?',
    },
    goal: {
        created: 'Ziel erfolgreich erstellt',
        error_creating: 'Fehler beim Erstellen des Ziels',
        updated: 'Ziel erfolgreich aktualisiert',
        deleted: 'Ziel erfolgreich gelöscht',
        confirm_delete_goal: 'Bist du sicher, dass du dieses Ziel löschen möchtest?'
    },
    date_required: 'Bitte wähle ein Datum aus',
    date_in_past: 'Das Datum darf nicht in der Vergangenheit liegen',
    amount_required: 'Bitte gib einen gültigen Betrag ein',
    icon_required: 'Bitte wähle ein Icon aus',
    name_required: 'Bitte gib einen Namen ein',
}
</script>
